// Check if backend is available
export const checkBackendHealth = async (): Promise<boolean> => {
  try {
    // Use empty string for Vite proxy in dev, full URL in production
    const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';
    const response = await fetch(`${API_BASE_URL}/api/health`);
    return response.ok;
  } catch (error) {
    return false;
  }
};